document.addEventListener("DOMContentLoaded", () => {

  // Run only on products tagged "Premium Printshield Case"
  if (!window.isPhoneCase) return;

  const firstImage = document.querySelector(".product__media img");
  if (!firstImage) return;

  const frame = document.createElement("img");
  frame.className = "cc-frame-overlay";
  firstImage.parentElement.appendChild(frame);

  // Default preview
  frame.src = window.phoneFrames["iphone-17"];
  frame.classList.add("active");

  // Preload all phone frame images
  Object.values(window.phoneFrames).forEach(src => {
    const img = new Image();
    img.src = src;
  });

  function updateFrame() {

    const dropdowns = document.querySelectorAll(".dropdown-button__value");

    let detectedKey = null;

    dropdowns.forEach(dropdown => {

      const text = dropdown.textContent.trim();

      // Ignore empty/default values
      if (
        !text ||
        text.toLowerCase().includes("select") ||
        text === "--- Please select ---"
      ) {
        return;
      }

      const key = text
        .toLowerCase()
        .replace(/\s+/g, "-");

      // Match against our phone frame keys
      if (window.phoneFrames[key]) {
        detectedKey = key;
      }

    });

    if (!detectedKey) return;

    console.log("Detected Model:", detectedKey);

    const newSrc = window.phoneFrames[detectedKey];

    if (frame.dataset.currentFrame === newSrc) {
      return;
    }

    frame.dataset.currentFrame = newSrc;

    frame.classList.remove("active");

    setTimeout(() => {
      frame.src = newSrc;
      frame.classList.add("active");
    }, 50);

  }

  const observer = new MutationObserver(updateFrame);

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true
  });

  updateFrame();

});

function updateCartFrames() {

  document.querySelectorAll("[data-cart-item]").forEach(item => {

    const frame = item.querySelector("[data-cart-frame]");
    if (!frame) return;

    let detectedKey = null;

    item.querySelectorAll("dl .product-option").forEach(option => {

      const text = option.textContent
        .trim()
        .toLowerCase();

      Object.keys(window.phoneFrames).forEach(key => {

        const readableKey = key.replace(/-/g, " ");

        if (text.includes(readableKey)) {
          detectedKey = key;
        }

      });

    });

    if (!detectedKey) return;

    const frameUrl = window.phoneFrames[detectedKey];

    if (!frameUrl) return;

    frame.src = frameUrl;

  });

}

document.addEventListener("DOMContentLoaded", updateCartFrames);

new MutationObserver(updateCartFrames).observe(document.body, {
  subtree: true,
  childList: true
});